'use strict';

angular.module('directives.iamEvent')

.controller('iamEventDirectiveOnHoldToProcessAccessRequestsPendingController', ['$scope', '$state', 'userAccessRequestService', function ($scope, $state, userAccessRequestService) {

    $scope.ctrlCtxt.showContinueAction = false;

    // Get Requests On Hold
    userAccessRequestService
        .getOnHoldUserAccessRequestsByEmployeeID($scope.model.EmployeeID)
        .then(function (reqsOnHold) {
            $scope.ctrlCtxt.showContinueAction = reqsOnHold.length === 0;
        });

    // Show Continue Action?
    $scope.showContinueAction = function () {
        return $scope.ctrlCtxt.showContinueAction;
    };

    // Is Departure?
    $scope.isDeparture = function () {
        return $scope.model.EventTypeID === 38; // EMPLOYEE/IAM/DEPARTURE
    };

    $scope.isTransfer = function () {
        return $scope.model.EventTypeID === 42; // EMPLOYEE/IAM/TRANSFER
    }

    // Go To Employee User Requests
    $scope.goToEmployeeUserRequests = function ($event) {
        $event.stopPropagation();

        $state.go('userAccessRequest.request.byEmployeeId', { employeeId: $scope.model.EmployeeID });
    };
}]);